import sensecommon from "@sensechat/user-inteceptor";
import { register } from "@sensechat/crypto-interceptor/fetch";

import { HTTP_STATUS } from "../constants/request";
import { v4 as uuidv4 } from "uuid";

import chalk from "./chalk";
import { SenseChat } from "./error";
import { META_DATA } from "../constants";

interface IParams {
  url: string;
  options?: Record<string, any>;
  onMessage?: (val: any) => Promise<void> | void;
  onFinish?: () => Promise<void> | void;
  onError?: (err: Error) => Promise<void> | void;
}

function delay(ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

if (API_ENCRYPT) {
  register({
    excludeInterfaces: [
      { host: location.host, route: "/api/assistant/*", method: "*" },
      { host: location.host, route: "/api/buddy/*", method: "*" },
      { host: location.host, route: "/api/moe/*", method: "*" },
      { host: location.host, route: "/api/filechat/*", method: "*" },
      { host: location.host, route: "/api/global/*", method: "*" },
      { host: "www.googleapis.com", route: "*", method: "*" },
      { host: "identitytoolkit.googleapis.com", route: "*", method: "*" },
      { host: "securetoken.googleapis.com", route: "*", method: "*" },
      { host: "api-js.mixpanel.com", route: "*", method: "*" },
    ],
  });
}

export const createStreamFetch = ({
  url,
  options = {},
  onFinish,
  onMessage,
  onError,
}: IParams): {
  abort: () => void;
  exec: () => void;
} => {
  const controller = new AbortController();
  let hasStop = false;

  const abort = () => {
    hasStop = true;
    controller.abort();
  };

  const fetchStream = async () => {
    try {
      const response = await sensecommon.http.fetch(url, {
        signal: controller.signal,
        headers: {
          "Content-Type":
            options.method === "GET"
              ? undefined
              : "application/json;charset=UTF-8",
          "X-Request-Id": uuidv4(),
          "debug": OPEN_REQUEST_LOG ? "debug" : undefined,
          "system-type": META_DATA.projectName === "mbs" ? "h5" : "web",
          "version-code": "",
        },
        ...options,
        body: JSON.stringify(options.body),
      });
      if (response.status !== HTTP_STATUS.SUCCESS) {
        throw Error(JSON.stringify(response));
      }
      if (OPEN_REQUEST_LOG) {
        chalk.request(options.url, JSON.stringify(options.body));
      }
      const reader = response!.body!.getReader();
      let cache = "";
      const regStart = /^data:\s?\{/;
      const regEnd = /\n\n$/;
      const dispatchRaw = async (raw: string) => {
        if (!raw) return;
        // raw = raw.trim()
        const matches = raw
          .split("\n\n")
          .map((item: string) => item.trim())
          .filter((item: string) => item);
        for (let data of matches) {
          data = data.substr(5);
          data = JSON.parse(data);
          (data as any).code = SenseChat.code2Status((data as any).code);
          // setTimeout(() => {
          //     onMessage?.(data)
          // }, 1000)
          // console.log("lllll", data);
          if (!hasStop) {
            await onMessage?.(data);
            // await delay(40);
          } else {
            break;
          }
        }
      };
      while (!hasStop) {
        const { value, done } = await reader.read();
        if (done) {
          console.log("stream end!!!");
          onFinish?.();
          break;
        }
        const utf8Decoder = new TextDecoder("utf-8");
        let raw: any = value ? utf8Decoder.decode(value, { stream: true }) : "";
        chalk.streamResponse(raw);
        if (cache) {
          raw = cache + raw;
        }

        // raw = raw.trim()
        if (raw) {
          if (regStart.test(raw) && regEnd.test(raw)) {
            cache = "";
            await dispatchRaw(raw);
          } else if (regStart.test(raw) && !regEnd.test(raw)) {
            console.log("breakpoint envoke1");
            const lastNN = (raw as string).lastIndexOf("\n\n");
            if (lastNN > -1) {
              await dispatchRaw(raw.slice(0, lastNN));
              cache = raw.slice(lastNN + 2);
            } else {
              cache = raw;
            }
          } else if (!regStart.test(raw) && !regEnd.test(raw)) {
            console.log("breakpoint envoke2");
            cache = raw;
          } else {
            console.log("breakpoint envoke3");
            console.log("[cache]: ", cache);
            await dispatchRaw(raw);
            cache = "";
          }
        }
      }
    } catch (err: any) {
      if (err.name !== "AbortError") {
        console.log("fetchStream err: ", err);
        onError?.(err);
      }
    }
  };
  return {
    abort,
    exec: fetchStream,
  };
};
